import request from '@/utils/request';

// ------------------------ 系统
// 登录
export const adminLoginApi = params => {
  return request.post('/api/admin/login', params);
};

// 获取用户详情
export const getAdminInfoByTokenApi = () => {
  return request.get('/api/admin/getAdminInfoByToken');
};

// 登出
export const adminLogout = () => {
  return request.get('/api/admin/logout');
};

// ------------------------ 子账号
// 子账号列表
export const sysAdminListApi = params => {
  return request.post('/api/admin/system/admin/list', {
    params,
  });
};

// 添加子账号
export const sysAdminSaveApi = params => {
  return request.post('/api/admin/system/admin/save', params);
};

// 修改子账号
export const sysAdminUpdateApi = params => {
  return request.post('/api/admin/system/admin/update', params);
};

// 删除子账号
export const sysAdminDeleteApi = params => {
  return request.get('/api/admin/system/admin/delete', {
    params,
  });
};

// ------------------------ 会员管理
// 会员列表
export const adminUserListApi = params => {
  return request.post('/api/admin/user/list', params);
};

// 会员详情
export const adminUserInfoApi = params => {
  return request.get('/api/admin/user/info', params);
};

// 推荐人分页列表
export const adminUserSpreadListApi = params => {
  return request.post('/api/admin/user/spread/list', params);
};

// 设置会员级别
export const adminUserTagApi = params => {
  return request.post('/api/admin/user/tag', params);
};

// 积分管理
// 积分流水列表
export const adminUserIntegralListApi = params => {
  return request.post('/api/admin/user/integral/list', params);
};

// 加减积分余额
export const adminUserIntegralOperateFoundsApi = params => {
  return request.post('/api/admin/user/integral/operate/founds', params);
};

// ------------------------ 轮播图管理
// Slider查询
export const getSliderListApi = params => {
  return request.post('/api/admin/slider/list', params);
};

// 新增Slider
export const createSliderApi = params => {
  return request.post('/api/admin/slider/save', params);
};

// 修改Slider
export const updateSliderApi = params => {
  return request.post('/api/admin/slider/update', params);
};

// 删除Slider
export const deleteSliderApi = params => {
  return request.post('/api/admin/slider/delete', params);
};

// ------------------------ 线下课程
// 类型
// 查询线下课程类型
export const courseOfflineCategoryListApi = params => {
  return request.post('/api/admin/course-offline-category/list', params);
};

// 删除线下课程类型
export const courseOfflineCategoryDeleteApi = params => {
  return request.post('/api/admin/course-offline-category/delete', params);
};

// 新增线下课程类型
export const courseOfflineCategorySaveApi = params => {
  return request.post('/api/admin/course-offline-category/save', params);
};

// 更新线下课程类型
export const courseOfflineCategoryUpdateApi = params => {
  return request.post('/api/admin/course-offline-category/update', params);
};

// 更新线下课程类型顺序
export const courseOfflineCategorySortApi = params => {
  return request.post('/api/admin/course-offline-category/sort', params);
};


// 课程
// 删除线下课程类型
export const courseOfflineDeleteApi = params => {
  return request.post('/api/admin/course-offline/delete', params);
};

// 查询线下课程详情
export const courseOfflineInfoApi = params => {
  return request.get('/api/admin/course-offline/info', {
    params
  });
};

// 查询线下课程列表
export const courseOfflineListApi = params => {
  return request.post('/api/admin/course-offline/list', params);
};

// 新增线下课程
export const courseOfflineSaveApi = params => {
  return request.post('/api/admin/course-offline/save', params);
};

// 上架/下架线下课程
export const courseOfflineStatusApi = params => {
  return request.post('/api/admin/course-offline/status', params);
};

// 更新线下课程
export const courseOfflineUpdateApi = params => {
  return request.post('/api/admin/course-offline/update', params);
};


// 线下课程报名列表
export const courseOfflineSignUpListApi = params => {
  return request.post('/api/admin/course-offline/sign-up/list', params);
};


// ------------------------ 视频课程
// 类型
// 查询视频课程类型
export const courseOnlineCategoryListApi = params => {
  return request.post('/api/admin/course-online-category/list', params);
};

// 删除视频课程类型
export const courseOnlineCategoryDeleteApi = params => {
  return request.post('/api/admin/course-online-category/delete', params);
};

// 新增视频课程类型
export const courseOnlineCategorySaveApi = params => {
  return request.post('/api/admin/course-online-category/save', params);
};

// 更新视频课程类型
export const courseOnlineCategoryUpdateApi = params => {
  return request.post('/api/admin/course-online-category/update', params);
};

// 更新商品课程类别顺序
export const courseOnlineCategorySortApi = params => {
  return request.post('/api/admin/course-online-category/sort', params);
};


// 线上课程报名列表
export const courseOnlineSignUpListApi = params => {
  return request.post('/api/admin/course-online/sign-up/list', params);
};


// 课程
// 查询课程
export const courseOnlineListApi = params => {
  return request.post('/api/admin/course-online/list', params);
};

// 查询课程详情
export const courseOnlineInfoApi = params => {
  return request.get('/api/admin/course-online/info', {
    params,
  });
};

// 删除课程
export const courseOnlineDeleteApi = params => {
  return request.post('/api/admin/course-online/delete', params);
};

// 新增课程
export const courseOnlineSaveApi = params => {
  return request.post('/api/admin/course-online/save', params);
};

// 更新课程
export const courseOnlineUpdateApi = params => {
  return request.post('/api/admin/course-online/update', params);
};

// 更新课程状态
export const courseOnlineStatusApi = params => {
  return request.post('/api/admin/course-online/status', params);
};

// 保存线上子课程
export const courseOnlineVideoSaveApi = params => {
  return request.post('/api/admin/course-online/video/save', params);
};


// 查询线上子课程列表
export const courseOnlineVideoListApi = params => {
  return request.post('/api/admin/course-online/video/list', params);
};

// 线上课程订单列表
export const courseOnlineOrderListApi = params => {
  return request.post('/api/admin/store/order/list', params);
};






// ------------------------ 活动
// 类型
// 查询活动类型
export const activityCategoryListApi = params => {
  return request.post('/api/admin/activity-category/list', params);
};

// 删除活动类型
export const activityCategoryDeleteApi = params => {
  return request.post('/api/admin/activity-category/delete', params);
};

// 新增活动类型
export const activityCategorySaveApi = params => {
  return request.post('/api/admin/activity-category/save', params);
};

// 更新活动类型
export const activityCategoryUpdateApi = params => {
  return request.post('/api/admin/activity-category/update', params);
};

// 更新活动顺序
export const activityCategorySortApi = params => {
  return request.post('/api/admin/activity-category/sort', params);
};

// 置顶活动
export const activityTopApi = params => {
  return request.post('/api/admin/activity/top', params);
};

// 取消置顶活动
export const activityCancelTopApi = params => {
  return request.post('/api/admin/activity/cancel-top', params);
};

// 活动
// 查询活动
export const activityListApi = params => {
  return request.post('/api/admin/activity/list', params);
};

// 查询活动详情
export const activityInfoApi = params => {
  return request.get('/api/admin/activity/info', {
    params,
  });
};

// 删除活动
export const activityDeleteApi = params => {
  return request.post('/api/admin/activity/delete', params);
};

// 新增活动
export const activitySaveApi = params => {
  return request.post('/api/admin/activity/save', params);
};

// 更新活动
export const activityUpdateApi = params => {
  return request.post('/api/admin/activity/update', params);
};

// 更新活动状态
export const activityStatusApi = params => {
  return request.post('/api/admin/activity/status', params);
};

// 活动报名列表
export const activitySignUpListApi = params => {
  return request.post('/api/admin/activity/sign-up/list', params);
};

// -------------- 课程级别
export const courseLevelListApi = params => {
  return request.post('/api/admin/course-level/list', params);
};






// ------------------改

// 公益课类型
// 查询线下课程类型
export const courseWelfareCategoryListApi = params => {
  return request.post('/api/admin/course-welfare-category/list', params);
};

// 删除线下课程类型
export const courseWelfareCategoryDeleteApi = params => {
  return request.post('/api/admin/course-welfare-category/delete', params);
};

// 新增线下课程类型
export const courseWelfareCategorySaveApi = params => {
  return request.post('/api/admin/course-welfare-category/save', params);
};

// 更新线下课程类型
export const courseWelfareCategoryUpdateApi = params => {
  return request.post('/api/admin/course-welfare-category/update', params);
};

// 更新线下课程类型顺序
export const courseWelfareCategorySortApi = params => {
  return request.post('/api/admin/course-welfare-category/sort', params);
};

// 公益课课程
// 删除线下课程类型
export const courseWelfareDeleteApi = params => {
  return request.post('/api/admin/course-welfare/delete', params);
};

// 查询线下课程详情
export const courseWelfareInfoApi = params => {
  return request.get('/api/admin/course-welfare/info', {
    params
  });
};

// 查询线下课程列表
export const courseWelfareListApi = params => {
  return request.post('/api/admin/course-welfare/list', params);
};

// 新增线下课程
export const courseWelfareSaveApi = params => {
  return request.post('/api/admin/course-welfare/save', params);
};

// 上架/下架线下课程
export const courseWelfareStatusApi = params => {
  return request.post('/api/admin/course-welfare/status', params);
};

// 更新线下课程
export const courseWelfareUpdateApi = params => {
  return request.post('/api/admin/course-welfare/update', params);
};


// 公益课报名列表
export const courseWelfareSignUpListApi = params => {
  return request.post('/api/admin/course-welfare/sign-up/list', params);
};


// ------------------------ vip课程类型
// 类型
// 查询视频课程类型
export const vipCourseCategoryListApi = params => {
  return request.post('/api/admin/course-category/list', params);
};

// 删除视频课程类型
export const vipCourseCategoryDeleteApi = params => {
  return request.post('/api/admin/course-category/delete', params);
};

// 新增视频课程类型
export const vipCourseCategorySaveApi = params => {
  return request.post('/api/admin/course-category/save', params);
};

// 更新视频课程类型
export const vipCourseCategoryUpdateApi = params => {
  return request.post('/api/admin/course-category/update', params);
};

// 更新商品课程类别顺序
export const vipCourseCategorySortApi = params => {
  return request.post('/api/admin/course-category/sort', params);
};



// 查询充值列表
export const rechargeListApi = params => {
  return request.post('/api/admin/store/order/recharge/list', params);
};


// 设置轮播图排序
export const sliderListApi = params => {
  return request.post('/api/admin/slider/list', params);
};




